export const REPORT_NAMES = {
  MEDIA_STATUS_REPORT: "Media Status Report",
  CAMPAIGN_SCHEDULE_STATUS_REPORT: "Campaign Schedule Status Report",
};
